import { useId, useRef, useState } from "react";

import { GrossAndTax } from "../../utils/taxWithheld";
import { NetToGrossFields } from "./NetToGrossFields";
import { HelperToggle } from "./styles";
import { NetToGrossHelperProps } from "./types";

const APPLIED_VALUE_OPTIONS = { shouldDirty: true, shouldValidate: true };

export const NetToGrossHelper = ({
  setValue,
  disabled = false,
}: NetToGrossHelperProps) => {
  const fieldsId = useId();
  const toggleRef = useRef<HTMLButtonElement>(null);
  const [isOpen, setIsOpen] = useState(false);
  const controlledId = isOpen ? fieldsId : undefined;

  const toggle = () => setIsOpen((open) => !open);

  const applyDerived = ({ grossAmount, taxWithheld }: GrossAndTax) => {
    setValue("amount", String(grossAmount), APPLIED_VALUE_OPTIONS);
    setValue("taxWithheld", String(taxWithheld), APPLIED_VALUE_OPTIONS);
    setIsOpen(false);
    toggleRef.current?.focus();
  };

  return (
    <>
      <HelperToggle
        ref={toggleRef}
        type="button"
        disabled={disabled}
        aria-expanded={isOpen}
        aria-controls={controlledId}
        onClick={toggle}
      >
        Only have the net?
      </HelperToggle>
      {isOpen && (
        <NetToGrossFields
          id={fieldsId}
          disabled={disabled}
          onApply={applyDerived}
        />
      )}
    </>
  );
};
